import { getTemplatePropertyMinimalStyles } from './Property.styles'
import type {} from './types/Property.type'

class Property extends HTMLElement {
  static get observedAttributes() {
    return ['name', 'value', 'container-class', 'container-part']
  }

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })

    this.shadowRoot!.appendChild(getTemplatePropertyMinimalStyles().content.cloneNode(true))

    this.render()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null) {
    if (['name', 'value', 'container-class', 'container-part'].includes(name)) {
      this.render()
    }
  }

  private render() {
    if (!this.shadowRoot) return

    const containerClass = this.getAttribute('container-class') || 'wa-split'
    const containerPart = this.getAttribute('container-part') || 'property-item'
    const name = this.getAttribute('name') || ''
    const value = this.getAttribute('value') || ''

    // Find existing content div or create structure
    let contentDiv = this.shadowRoot.querySelector('.property-content')
    if (!contentDiv) {
      contentDiv = document.createElement('div')
      contentDiv.className = 'property-content'
      this.shadowRoot.appendChild(contentDiv)
    }

    contentDiv.innerHTML = `
      <div class="${containerClass}" part="${containerPart}">
        <p class="prop-name" part="name">${name}</p>
        <p class="prop-value" part="value">${value}</p>
      </div>
    `
  }
}

if (!customElements.get('ts-property')) {
  customElements.define('ts-property', Property)
}
export { Property }
